module.exports = __webpack_public_path__ + "static/media/dla.32590dc4b3103087a58af92b83264484.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/dla.png
// module id = 2660
// module chunks = 1